import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withModifiers as _withModifiers, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "plan-header-additional" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("span", { class: "detail" }, "40%", -1)
const _hoisted_3 = { class: "detail" }
const _hoisted_4 = { class: "plan-content" }
const _hoisted_5 = {
  id: "distribute-allocation-form",
  class: "form distribute-allocation",
  method: "POST"
}
const _hoisted_6 = { class: "action-buttons" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_RangeSlider = _resolveComponent("RangeSlider")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("p", _hoisted_1, [
      _createTextVNode(" Please Distribute "),
      _hoisted_2,
      _createTextVNode(" allocation of "),
      _createElementVNode("span", _hoisted_3, _toDisplayString(_ctx.beneficiary.Name), 1),
      _createTextVNode(" among others beneficiary.")
    ]),
    _createElementVNode("div", _hoisted_4, [
      _createElementVNode("form", _hoisted_5, [
        _createVNode(_component_RangeSlider, {
          sliders: _ctx.sliders,
          isEditable: _ctx.isEditable
        }, null, 8, ["sliders", "isEditable"]),
        _createElementVNode("div", _hoisted_6, [
          _createElementVNode("a", {
            href: "",
            class: "btn btn-primary plan-modal",
            onClick: _cache[0] || (_cache[0] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.handleSubmit && _ctx.handleSubmit(...args)), ["prevent"]))
          }, _toDisplayString(_ctx.isEditable ? 'Save' : 'Distribute allocation'), 1)
        ])
      ])
    ])
  ], 64))
}